import React from "react";
import { connect } from "react-redux";
import Alert from "@material-ui/lab/Alert";
import * as actions from "../../store/actions/index";
import Snackbar from "@material-ui/core/Snackbar";

const AlertSnackBar = (props) => {
  const { isPopup, statusForSnackbar, editMapState } = props;

  const alertSnackBarDuration = 5000;

  const vertical = "top";
  const horizontal = "right";

  const handleClose = () => {
    editMapState({
      isPopup: 0,
    });
  };

  return isPopup === 1 && statusForSnackbar === 1 ? (
    <Snackbar
      open={isPopup > 0}
      autoHideDuration={alertSnackBarDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal }}
    >
      <Alert variant="filled" style={{ backgroundColor: "yellow" }}>
        Εισερχόμενη Ειδοποίηση : Χαμηλού Κινδύνου
      </Alert>
    </Snackbar>
  ) : isPopup === 2 && statusForSnackbar === 1 ? (
    <Snackbar
      open={isPopup > 0}
      autoHideDuration={alertSnackBarDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal }}
    >
      <Alert variant="filled" color="warning">
        Εισερχόμενη Ειδοποίηση : Μετρίου Κινδύνου
      </Alert>
    </Snackbar>
  ) : isPopup === 3 && statusForSnackbar === 1 ? (
    <Snackbar
      open={isPopup > 0}
      autoHideDuration={alertSnackBarDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal }}
    >
      <Alert variant="filled" color="error">
        Εισερχόμενη Ειδοποίηση : Υψηλού Κινδύνου
      </Alert>
    </Snackbar>
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    ...state.map,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editMapState: (mapPayload) => {
      dispatch(actions.editMapState(mapPayload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertSnackBar);
